import * as React from 'react';
import type { SVGProps } from 'react';
const SvgWhatsapp = (props: SVGProps<SVGSVGElement>) => (
  <svg xmlns="http://www.w3.org/2000/svg" width={23} height={21} viewBox="0 0 124 124" {...props}>
    <path
      d="M633.071 801.984a41.679 41.679 0 0 1-19.556-4.839c-7.257 1.879-16.754 4.888-23.517 6.862 1.866-6.157 6.021-19.17 6.885-22.8a41.917 41.917 0 1 1 36.188 20.777Zm0-76.419a34.442 34.442 0 0 0-28.41 53.811c-.918 3.509-3.018 10.251-4.221 14.172 4.422-1.584 9.8-3.345 13.772-4.768a34.409 34.409 0 1 0 18.859-63.215Zm-8.271 45.322c-20.743-19.628-10.225-28.347-6.961-30.5s5.221 0 5.221 0 2.3 5.35 3.481 7.844a4.7 4.7 0 0 1 0 4.358l-3.481 3.486c3.99 10.338 15.663 14.817 15.663 14.817a49.555 49.555 0 0 0 4.351-4.358 1.971 1.971 0 0 1 2.61-.871c.706.359 7.958 3.979 8.7 4.357a2.6 2.6 0 0 1 .87 3.487c-1.077 2.006-9.536 17.169-30.454-2.62Z"
      data-name="\u5F62\u72B6 884"
      style={{
        fill: 'currentColor',
        fillRule: 'evenodd',
      }}
      transform="translate(-568 -701)"
    />
  </svg>
);
export default SvgWhatsapp;
